var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.role(
      'admin',
      'departmentManager',
      'manager',
      'safetyRepresentative'
    )
  )?_c('v-btn',{staticClass:"primary accent-4 white--text mr-2 my-1",attrs:{"small":""},on:{"click":_vm.reset}},[_vm._v("\n  "+_vm._s(_vm.$t("profile.assignment.resetPassword"))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }